var angularModule = angular.module('t2g.common.directives.confirmButtonDirective', ['gettext']);

module.exports = angularModule;

angularModule.directive('confirmButton', function($compile, gettextCatalog) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      action: '&',
      message: '@',
      placement: '@',
    },
    link: function($scope, $element) {
      var settings = {
        action: $scope.action,
        placement: $scope.placement || 'top',
        message: $scope.message || gettextCatalog.getString('realy?'),
        yes: gettextCatalog.getString('yes'),
        no: gettextCatalog.getString('no'),
      };

      /**
       * hide the popover
       */
      var hidePopover = function() {
        $element.popover('hide');
      };

      $element
        .popover({
          title: gettextCatalog.getString('warning'),
          trigger: 'click',
          placement: settings.placement,
          container: $element,
          html: true,
          content: $compile(
            '<p class="deletebutton-message">' +
              settings.message +
              '</p><p class="deletebutton-message"><button class="btn btn-danger" ng-click="confirm()">' +
              settings.yes +
              '</button><button class="btn" ng-click="deny()">' +
              settings.no +
              '</button></p>',
          )($scope),
        })
        .on('click', '.popover', function(event) {
          event.stopPropagation();
          event.preventDefault();
        });

      /**
       * close the popover if messages was denied
       */
      $scope.deny = function() {
        hidePopover();
      };

      /**
       * run action if message was confirmed
       */
      $scope.confirm = function() {
        hidePopover();

        if (settings.action) {
          $scope.$eval(settings.action);
        }
      };

      /**
       * GC
       */
      $scope.$on('$destroy', function() {
        $element.off();
      });
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/directives/confirmButtonDirective.js